import {
  CLIENTMANAGER_REQUEST,
  CLIENTMANAGER_SUCCESS,
  CLIENTMANAGER_FAILURE,
  CLIENT_REQUEST,
  CLIENT_SUCCESS,
  CLIENT_FAILURE,
  CLIENT_UPDATE_REQUEST,
  CLIENT_UPDATE_SUCCESS,
  CLIENT_UPDATE_FAILURE,
  CLIENTS_TYPEAHEAD_REQUEST,
  CLIENTS_TYPEAHEAD_SUCCESS,
  CLIENTS_TYPEAHEAD_FAILURE,
  CLIENT_GET_FILES_REQUEST,
  CLIENT_GET_FILES_SUCCESS,
  CLIENT_GET_FILES_FAILURE,
  CLIENT_UPLOAD_FILES_REQUEST,
  CLIENT_UPLOAD_FILES_SUCCESS,
  CLIENT_UPLOAD_FILES_FAILURE,
  CLIENT_GET_FILE_REQUEST,
  CLIENT_GET_FILE_SUCCESS,
  CLIENT_GET_FILE_FAILURE,
  CLIENT_PREVIEW_FILE_REQUEST,
  CLIENT_PREVIEW_FILE_SUCCESS,
  CLIENT_PREVIEW_FILE_FAILURE,
  CLIENT_UPDATE_FILE_REQUEST,
  CLIENT_UPDATE_FILE_SUCCESS,
  CLIENT_UPDATE_FILE_FAILURE,
  CLIENT_DELETE_FILE_REQUEST,
  CLIENT_DELETE_FILE_SUCCESS,
  CLIENT_DELETE_FILE_FAILURE,
  CLIENT_TPA_SUBGROUPS_REQUEST,
  CLIENT_TPA_SUBGROUPS_SUCCESS,
  CLIENT_TPA_SUBGROUPS_FAILURE,
  CLIENT_REPORT_CATEGORIES_REQUEST,
  CLIENT_REPORT_CATEGORIES_SUCCESS,
  CLIENT_REPORT_CATEGORIES_FAILURE
} from './ClientManagerActions';

const initialState = {
  data: [],
  fileName: null,
  client: {},
  error: null,
  isLoading: false,
  typeahead: [],
  files: {},
  isFilesLoading: false,
  uploads: {},
  isFilesUploading: false,
  isFileDeleting: false,
  isFileUpdating: false,
  isFileDownloading: false,
  tpaSubGroups: [],
  categories: []
};

export default function clientManagerReducer(
  state = initialState,
  { type, payload, meta },
) {
  switch (type) {
    case CLIENTMANAGER_REQUEST:
      return { ...state, isLoading: true };
    case CLIENTMANAGER_SUCCESS:
      return {
        ...state,
        data: payload.data,
        client: {},
        error: null,
        isLoading: false,
      };
    case CLIENTMANAGER_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case CLIENT_REQUEST:
      return { ...state, isLoading: true };
    case CLIENT_SUCCESS:
      return { ...state, client: payload.data, errors: null, isLoading: false };
    case CLIENT_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case CLIENT_UPDATE_REQUEST:
      return { ...state, isLoading: true };
    case CLIENT_UPDATE_SUCCESS:
      return { ...state, client: payload.data, errors: null, isLoading: false };
    case CLIENT_UPDATE_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case CLIENTS_TYPEAHEAD_REQUEST:
      return { ...state, isLoading: true };
    case CLIENTS_TYPEAHEAD_SUCCESS:
      return {
        ...state,
        typeahead: payload.data,
        errors: null,
        isLoading: false,
      };
    case CLIENTS_TYPEAHEAD_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case CLIENT_GET_FILES_REQUEST:
      return { ...state, isFilesLoading: true };
    case CLIENT_GET_FILES_SUCCESS:
      return {
        ...state,
        files: { ...state.actions, [meta.clientCode]: payload.data },
        errors: null,
        isFilesLoading: false,
      };
    case CLIENT_GET_FILES_FAILURE:
      return {
        ...state,
        error: payload.error,
        isFilesLoading: false,
      };

    case CLIENT_UPLOAD_FILES_REQUEST:
      return { ...state, uploads: {}, isFilesUploading: true };
    case CLIENT_UPLOAD_FILES_SUCCESS:
      return {
        ...state,
        uploads: payload.data,
        errors: null,
        isFilesUploading: false,
      };
    case CLIENT_UPLOAD_FILES_FAILURE:
      return {
        ...state,
        error: payload.error,
        isFilesUploading: false,
      };

    case CLIENT_DELETE_FILE_REQUEST:
      return { ...state, isFileDeleting: true };
    case CLIENT_DELETE_FILE_SUCCESS:
      return {
        ...state,
        isFileDeleting: false,
      };
    case CLIENT_DELETE_FILE_FAILURE:
      return {
        ...state,
        error: payload.error,
        isFileDeleting: false,
      };

    case CLIENT_UPDATE_FILE_REQUEST:
      return { ...state, isFileUpdating: true };
    case CLIENT_UPDATE_FILE_SUCCESS:
      return {
        ...state,
        isFileUpdating: false,
      };
    case CLIENT_UPDATE_FILE_FAILURE:
      return {
        ...state,
        error: payload.error,
        isFileUpdating: false,
      };

    case CLIENT_GET_FILE_REQUEST:
      return { ...state, isFileDownloading: true };
    case CLIENT_GET_FILE_SUCCESS:
      return { ...state, isFileDownloading: false };
    case CLIENT_GET_FILE_FAILURE:
      return { ...state, isFileDownloading: false };

    case CLIENT_PREVIEW_FILE_REQUEST:
      return { ...state, isFileDownloading: true };
    case CLIENT_PREVIEW_FILE_SUCCESS:
      return { ...state, isFileDownloading: false };
    case CLIENT_PREVIEW_FILE_FAILURE:
      return { ...state, isFileDownloading: false };

    case CLIENT_REPORT_CATEGORIES_REQUEST:
      return { ...state, isLoading: true };
    case CLIENT_REPORT_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: payload.data,
        errors: null,
        isLoading: false,
      };
    case CLIENT_REPORT_CATEGORIES_FAILURE:
      return {
        ...state,
        error: payload.error,
        isLoading: false,
      };

    case CLIENT_TPA_SUBGROUPS_REQUEST:
      return { ...state, isLoading: true };
    case CLIENT_TPA_SUBGROUPS_SUCCESS:
      return {
        ...state,
        tpaSubGroups: payload.data,
        errors: null,
        isLoading: false,
      };
    case CLIENT_TPA_SUBGROUPS_FAILURE:
      return {
        ...state,
        error: payload.error,
        isLoading: false,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/client-manager/ClientManagerReducer.js